import React, { useCallback } from "react"
import { Box, Container, Stack, Typography } from "@mui/material"
import useTrans from "@/hooks/useTrans"
import Button from "@/components/base/Button"
import Image from "next/image"
import HeroAppImage from "@/assets/images/hero-app.png"
// import FiatUSDTImage from "@/assets/images/fiat-usdt.png"
// import FiatRENECImage from "@/assets/images/fiat-renec.png"
// import FiatBTCImage from "@/assets/images/fiat-btc.png"
// import FiatETHImage from "@/assets/images/fiat-eth.png"
// import FiatVNDImage from "@/assets/images/fiat-vnd.png"
import navbarLinks from "@/constants/navbarLinks"

const Hero = () => {
  const trans = useTrans()

  const handleScrollToWhyToChoose = useCallback(() => {
    const targetElement = document.getElementById("why-choose-renec-lend")
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" })
    }
  }, [])

  return (
    <Container maxWidth='xl'>
      <Stack alignItems='center' gap={3} className='mt-10'>
        {/* <Stack direction='row' alignItems='center' className='w-fit' gap={1}>
          <Stack direction='row' alignItems='center' spacing={-1} className=''>
            <Image alt='fiat-usdt' src={FiatUSDTImage} width={24} height={24} />
            <Image alt='fiat-renec' src={FiatRENECImage} width={24} height={24} />
            <Image alt='fiat-btc' src={FiatBTCImage} width={24} height={24} />
            <Image alt='fiat-eth' src={FiatETHImage} width={24} height={24} />
            <Image alt='fiat-vnd' src={FiatVNDImage} width={24} height={24} />
          </Stack>
          <Typography className='text-sm text-neutral-600'>+150 tokens</Typography>
        </Stack> */}

        <Stack alignItems='center' gap={1}>
          <Typography className='text-neutral-1000 text-center font-montserrat text-[2rem] sm:text-5xl font-bold leading-tight'>
            <span>{trans.home.title_p1}</span>
            <br />
            <span>{trans.home.title_p2}</span>
          </Typography>
          <Typography className='text-sm sm:text-base text-neutral-600 text-center sm:max-w-3xl'>
            {trans.home.sub_title}
          </Typography>
        </Stack>

        <Stack direction='row' alignItems='center' gap={1}>
          <Button variant='primary' size='lg' className='!capitalize px-10' href={navbarLinks.dashboard}>
            {trans.home.launch_app}
          </Button>
          <Button variant='outlined' size='lg' className='px-4' onClick={handleScrollToWhyToChoose}>
            {trans.home.why_choose_we}
          </Button>
        </Stack>

        <Box className='border-l-[6px] border-t-[6px] border-r-[6px] border-solid border-neutral-1000 rounded-tl-lg rounded-tr-lg sm:w-2/3'>
          <Image src={HeroAppImage} alt='hero-app' className='w-full' unoptimized priority />
        </Box>
      </Stack>
    </Container>
  )
}

export default Hero
